import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/_coach/library/sections")({
  component: RouteComponent,
  staticData: {
    getBreadcrumb: () => {
      return {
        href: "/library/sections",
        labelTranslationKey: "sectionsPage.breadcrumb",
      };
    },
  },
});

function RouteComponent() {
  return <Outlet />;
}
